// extracted by mini-css-extract-plugin
export default {"tooltip":"mq-z","sharingV2":"nq-z","sharingIconsV2":"oq-z","links":"pq-z","link":"qq-z","facebookV2":"rq-z","twitterV2":"sq-z","pinterestV2":"tq-z"};